module.exports = __webpack_public_path__ + "static/media/ios-medal.128a419a.svg";